/**
 * Messages de l'authentification
 */

module.exports = {

    legalFiles: {
        termsOfUse: {
            label: 'CGU',
            altLabel: 'Consult the general conditions of use.'
        },
        privacyPolicy: {
            label: 'Privacy policy',
            altLabel: 'Consult the privacy policy'
        }
    },

    activation: {
        sendMail: {
            button: {
                label: 'Send them back to me'
            }
        }
    },

    // Page d'authentification
    login: {
        form: {
            title: 'Connect',
            register: {
                call: 'New on the plateform?',
                button: {
                    label: 'Create an account'
                }
            },
            genericError: 'An error occurred during authentication.',
            registrationValidationError: 'You should have received an e-mail confirming your registration. If this is not the case, please click <a href="{ url }" title="">here</a> to receive it again.',
            fields: {
                email: {
                    label: 'E-mail address'
                },
                password: {
                    label: 'Password'
                },
                rememberMe: {
                    label: 'Remember me'
                },
                submit: {
                    label: 'Log in'
                }
            },
            accountValidationRequired: 'Log in to your account to activate it.',
            fromInitPassword: 'Your password has been initialized. You can use it to log in.',
            fromResetPassword: 'Your password has been reset. You can use it to log in.',
            fromRegistrationValidationRequest: 'An e-mail validating your registration has been sent to the following adress { email }.',
            fromRemoveAccount: 'Your account has just been deleted.'
        },
        anchors: {
            forgotPassword: {
                label: 'Password forgotten'
            }
        }
    },

    // Page d'inscription
    register: {
        registered: {
            title: 'Please check your e-mail address by clicking on the link sent to your adress { email }',
            advice: 'Check your spam or the "Promotions" or "Notifications" tabs in your Gmail.',
            withoutNotification: 'Didn\'t you receive the e-mail?',
            sendActivationMail: {
                success: 'An e-mail was sent to the address { email }.',
                error: 'An error occurred while sending the e-mail.'
            }
        },

        loading: {
            resources: {
                error: 'An error occurred while loading the configuration.'
            }
        },
        form: {
            title: 'Create an account',
            login: {
                call: 'You already have an account?',
                button: {
                    label: 'Log in'
                }
            },
            error: 'An error occurred while creating your account.',
            // success: 'Your account has been created. An email has been sent to the address { email }. Please follow the link in the e-mail to activate your account.',
            fields: {
                firstName: 'First name',
                lastName: 'Last name',
                email: 'Professional e-mail address',
                phone: 'Phone number',
                societyName: 'Name of company',
                activitySector: 'Sector of activity and occupation',
                password: 'Password',
                passwordConfirmation: 'Confirm your password',
                siteUrl: 'Website',
                country: 'Country of residence',
                timeZone: 'Time Zone',
                applicationLang: 'Interface language',
                automaticVisibleTasks: 'Automatically display publications to the client',
                termsOfUse: 'I have read and accept the <a href="{ termsOfUseUrl }" title="">General Terms and Conditions</a>',
                privacyPolicy: 'I have read and accept the <a href="{ privacyPolicyUrl }" title="">Privacy Policy</a>',
                submit: 'Create an account',
            },

            description: {
                siteUrl: 'This will enable us to retrieve your information and save you time.',
                termsOfUse: 'I have read and accept the Terms and Conditions of Use of { applicationName }. I agree that the information provided may be used for commercial and communication purposes by { applicationName }. By validating the form, you accept that { applicationName } will store and use your e-mail address, your phone number and other information in order to contact you.'
            },

            placeholder: {
                siteUrl: 'https://www.your-url.com'
            },

            introduction: {
                title: 'Congratulations and very happy to see you among us! 🥳',
                error: 'An error occurred during recording.',
                button: {
                    next: 'Go !' // Forcément un point d'exclamation
                }
            },

            society: {
                title: 'Essential information',
                description: 'To understand your business and produce the best publications 😀',
                error: 'An error has occurred while saving your company information.',
                fields: {
                    commercialName: 'Commercial name',
                    siret: 'SIRET',
                    name: 'Company name',
                    summary: 'Activity summary',
                    siteUrl: 'Website',
                    workforce: 'Number of employees',
                    activityType: 'Activity type',
                    sector: 'Business sector and occupation'
                },
                descriptions: {
                    summary: 'Describe your activity in detail and the audiences you want to target.'
                }
            },
            editorialLine: {
                title: 'Editorial line',
                description: 'When it comes to communicating with your audience, you\'re more likely to :',
                error: 'An error occurred while saving your editorial line.'
            },
            graphicLine: {
                title: 'Graphic line',
                description: 'You can upload them later in the "My profile" section.',
                error: 'An error occurred while saving your graphic chart.'
            },
            notifications: {
                title: 'Notifications & Communication',
                contentTitle: 'One last important piece of information',
                description: 'How would you like us to communicate with you? This is very important, as you will receive notifications to validate your publications and you need to be reactive 😀. Choose the operating mode(s) that are the most convenient and comfortable for you.',
                information: 'You can change them later in the "My profile" section.',
                error: 'An error occurred while saving your notification preferences.'
            },
            socialNetwork: {
                title: 'Essentiel information',
                description: 'Connect your networks!',
                validateError: 'You must link at least one network to your account.'
            }
        },
        confirmation: {
            description: 'The “Website” field is not completed. If you have a website, please provide the URL. It will save you time during registration. <br /><br />Otherwise, you can create an account without a website,but additional questions will be asked to understand your business.',
            button: {
                confirm: {
                    label: 'I proceed without a website',
                },
                cancel: {
                    label: 'I provide the URL of my website'
                }
            }
        }
    },

    // Page de mot de passe oublié
    forgotPassword: {
        form: {
            title: 'Password forgotten',
            genericError: 'An error occurred while processing your request.',
            fields: {
                email: {
                    label: 'E-mail adress'
                },
                submit: {
                    label: 'Receive reset link'
                }
            },
            success: 'An e-mail to reset your password has been sent to the adress { email }.'
        },
        anchors: {
            login: {
                label: 'Back to login'
            }
        }
    },

    // Page de réinitialisation de mot de passe
    resetPassword: {
        form: {
            title: 'Password reset',
            genericError: 'An error occurred while resetting your password.',
            fields: {
                email: {
                    label: 'E-mail adress'
                },
                password: {
                    label: 'Password'
                },
                passwordConfirmation: {
                    label: 'Password confirmation'
                },
                submit: {
                    label: 'Password update'
                }
            }
        }
    },

    // Page d'initialisation de mot de passe
    initPassword: {
        form: {
            title: 'Initialize password',
            genericError: 'An error occurred during the initialization of your password.',
            fields: {
                password: {
                    label: 'Password'
                },
                passwordConfirmation: {
                    label: 'Password confirmation'
                },
                submit: {
                    label: 'Initialize password'
                }
            }
        }
    }

};
